import { AnyAction, combineReducers, Reducer } from "redux"
import { CasesActionTypes } from "../casesActionTypes"
import ICasesUIState from "../casesTypes"
import { defaultPerPage } from "../../../../shared/state/sharedTypes"

export const totalCasesCount: Reducer<number> = (state = 0, action: AnyAction): number => {
  switch (action.type) {
    case CasesActionTypes.FETCH_CASES_ASYNC_SUCCESS:
      return action.payload.totalItems
    default:
      return state
  }
}

export const totalPages: Reducer<number> = (state = 0, action: AnyAction): number => {
  switch (action.type) {
    case CasesActionTypes.FETCH_CASES_ASYNC_SUCCESS:
      return action.payload.totalPages
    default:
      return state
  }
}

export const appliedFilters: Reducer<string[]> = (state = [], action: AnyAction): string[] => {
  switch (action.type) {
    case CasesActionTypes.FETCH_CASES_ASYNC_SUCCESS:
      return action.payload.appliedFilters
    default:
      return state
  }
}

export const resultsPerPage: Reducer<number> = (state = defaultPerPage, action: AnyAction): number => {
  switch (action.type) {
    case CasesActionTypes.FETCH_CASES_ASYNC_SUCCESS:
      return action.payload.resultsPerPage
    default:
      return state
  }
}

export const searchTerm: Reducer<string> = (state = "", action: AnyAction): string => {
  switch (action.type) {
    case CasesActionTypes.FETCH_CASES_ASYNC_SUCCESS:
      return action.payload.searchTerm
    default:
      return state
  }
}

export const orderBy: Reducer<string> = (state = "updated_desc", action: AnyAction): string => {
  switch (action.type) {
    case CasesActionTypes.FETCH_CASES_ASYNC_SUCCESS:
      return action.payload.orderBy
    default:
      return state
  }
}

export const casesUIReducer: Reducer<ICasesUIState> = combineReducers({
  totalCasesCount,
  totalPages,
  appliedFilters,
  resultsPerPage,
  searchTerm,
  orderBy,
})
